import axios from "axios";
import apiUrls from "../apiUrls";

const actions = {

  async fetchServiceHistory( store, { serialNumber }) {

    try {
      const response = await axios.get(apiUrls.usedProductServiceHistory(serialNumber))

      return response.data.data
    } catch (e) {
      return null
    }

  },

  async clickOnTechVideo(store, { machine_id }) {

    try {
      const response = await axios.post(apiUrls.clickTechVideo, { machine_id });

      return response.data.data
    } catch (e) {
      return null
    }

  },

  async fetchBlogRelatedItems(store, id ) {
    try {
      const response = await axios.get(apiUrls.blogsRelatedItems(id));
      return response.data
    } catch (e) {
      return null
    }
  },

  async fetchYoutubeRelatedItems(store, id ) {
    try {
      const response = await axios.get(apiUrls.youtubeRelatedItems(id));
      return response.data
    } catch (e) {
      return null
    }
  }
}

export default {
  namespaced: true,
  actions
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/usedProduct.js